import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImgRight from "./../../images/x-p1.png";
import backgroundImgLeft from "./../../images/x-p2.png";

interface ArticleSectionProps {
  id?: string;
  layout: "article_left" | "article_right" | "article_left_bg" | "article_right_bg";
  title: string;
  content: React.ReactNode;
  imageUrl: string;
  backgroundColor: string;
}

const ArticleSection: React.FunctionComponent<ArticleSectionProps> = ({
  id = "",
  layout,
  title,
  content,
  imageUrl,
  backgroundColor,
}) => {
  const isBackground = layout.includes("_bg");
  const isLeft = layout.includes("left");

  const wrapper : React.CSSProperties = {
    marginTop: 100,
    marginBottom: 100
  };

  const bgHp: React.CSSProperties = {
    position: "relative",
    zIndex: 0
  };

  const apRow: React.CSSProperties = {
    display: "flex",
    alignItems: "center"
  };

  const textColumnStyle: React.CSSProperties = {
    flex: "1 1 50%",
    padding: "20px",
    textAlign: isLeft ? "right" : "left",
  };

  const imageColumnStyle: React.CSSProperties = {
    boxSizing: "inherit",
    //marginTop: -150,
    //marginBottom: 96
  };

  const imageStyle: React.CSSProperties = {
    width: "100%",
    height: "auto",
  };

  const subTitleStyle: React.CSSProperties = {
    fontSize: "64px",
    fontWeight: 300,
    wordWrap: "break-word",
    marginBottom: 30,
    color: "#514633",
    textTransform: "capitalize",
    fontFamily: "Avenir Next Codensed Ultralight",
    fontStyle: "normal",
    lineHeight: "62px",
    textAlign: isLeft ? "right" : "left",
    letterSpacing: ".03em",
    display: "block"
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "20px",
    lineHeight: "24px",
    textTransform: "capitalize",
    color: "#342714"
  };

  return (

    <section style={{...wrapper}} id={id}>
      <Container>
        <Row style={{ ...bgHp, ...apRow, background: "no-repeat" }} >
          {isBackground && <BgBeforeComponent background={backgroundColor} isLeft={isLeft}/>}
          <Col xxl={{order: isLeft ? "first" : "last", span: 6}} xl={{order: isLeft ? "first" : "last", span: 6}} lg={{order: isLeft ? "first" : "last", span: 6}} md={{order: isLeft ? "first" : "last", span: 6}} sm={{order: isLeft ? "first" : "last", span: 12}} xs={{order: isLeft ? "first" : "last", span: 12}}>
            {/* Text Column */}
            <div style={textColumnStyle}>
              <div style={subTitleStyle}>{title}</div>
              <div style={contentStyle}>{content}</div>
            </div>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
            {/* Image Column */}
            <div style={imageColumnStyle}>
              <img src={imageUrl} alt={title} style={imageStyle} />
            </div>
          </Col>
          <BgAfterComponent isLeft={isLeft}/>
        </Row>
      </Container>
    </section>
  );
};

export default ArticleSection;

interface BgBeforeComponentProps {
  background: string;
  isLeft: boolean;
}

const BgBeforeComponent: React.FunctionComponent<BgBeforeComponentProps> = ({background, isLeft}) => {
  const bgBefore: React.CSSProperties = {
    background: background ? background :"#DDEBEA",
    marginTop: "10%",
    transform: isLeft ? "translateX(50%)" : "translateX(-13%)",
    backgroundSize: "cover",
    content: "''",
    display: "block",
    position: "absolute",
    width: "50%",
    height: "80%",
    zIndex: -100,
    padding: "0 34%",
    overflow: "hidden",
  };
  return <div style={bgBefore}></div>;
}

interface BgAfterComponentProps {
  isLeft: boolean;
}

const BgAfterComponent: React.FunctionComponent<BgAfterComponentProps> = ({isLeft}) => {
  const bgAfter: React.CSSProperties = {
    content: "",
    background: `url(${isLeft ? backgroundImgLeft : backgroundImgRight}) no-repeat`,
    transform: isLeft ? "translateX(-50%)" : "none",
    width: 385,
    height: 661,
    position: "absolute",
    left: isLeft ? 0 : "auto",
    right: isLeft ? "auto" : 0,
    bottom: -30,
    overflow: "hidden",
    maxWidth: "100vw",
    opacity: "0.2",
    zIndex: -100,
  };
  return <div style={bgAfter}></div>;
}